import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import axios from "axios";
import confetti from "canvas-confetti"; // مكتبة أخف وأقوى
import { Ticket, X, ShieldCheck, AlertCircle, Loader2 } from "lucide-react";
import popSound from './sounds/popo.mp3';
import "./subscriptionModal.css";

const SubscriptionModal = ({ course, onClose }) => {
  const [subscriptionCode, setSubscriptionCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  // تأثير البلالين والاحتفال الاحترافي
  const fireCelebration = () => {
    const duration = 3 * 1000;
    const end = Date.now() + duration;

    const frame = () => {
      confetti({
        particleCount: 3,
        angle: 60,
        spread: 55,
        origin: { x: 0 },
        colors: ['#2563eb', '#7c3aed', '#10b981']
      });
      confetti({
        particleCount: 3,
        angle: 120,
        spread: 55,
        origin: { x: 1 },
        colors: ['#2563eb', '#7c3aed', '#10b981']
      });

      if (Date.now() < end) {
        requestAnimationFrame(frame);
      }
    };
    frame();

    // تشغيل صوت الـ Pop
    new Audio(popSound).play().catch(e => console.log("Audio play blocked"));
  };

  const handleSubmit = async () => {
    if (!subscriptionCode) {
      setError("من فضلك أدخل الكود أولاً");
      return;
    }

    setLoading(true);
    setError(null);

    const id = localStorage.getItem("id");
    const lesson_id = localStorage.getItem("package_id");
    const deviceFingerprint = localStorage.getItem("deviceFingerprint");

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/codes/validate`,
        {
          code: subscriptionCode,
          user_id: id,
          lesson_id: lesson_id,
          mac_address: deviceFingerprint,
        }
      );

      if (response.data.message === "Code validated and updated successfully.") {
        setSuccess(true);
        localStorage.setItem("subscriptionCode", subscriptionCode);
        fireCelebration();
        // إغلاق تلقائي بعد النجاح
        setTimeout(() => onClose(), 4000);
      }
    } catch (err) {
      const msg = err.response?.data?.message;
      setError(msg === "Code is already used." ? "🔎 الكود مستخدم من قبل" : "الكود غير صحيح، تأكد من البيانات");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <AnimatePresence>
        <motion.div
          className="modal-card"
          initial={{ scale: 0.8, opacity: 0, y: 50 }}
          animate={{ scale: 1, opacity: 1, y: 0 }}
          exit={{ scale: 0.8, opacity: 0, y: 50 }}
        >
          {/* زر الإغلاق */}
          <button className="close-icon-btn" onClick={onClose}>
            <X size={20} />
          </button>

          {!success ? (
            <div className="modal-body">
              <div className="icon-header">
                <div className="icon-circle">
                  <Ticket size={32} className="main-icon" />
                </div>
              </div>

              <h2>تفعيل المحتوى</h2>
              <p>أدخل كود الاشتراك الخاص بك لفتح المحاضرة فوراً</p>

              <div className={`input-wrapper ${error ? 'has-error' : ''}`}>
                <input
                  type="text"
                  value={subscriptionCode}
                  onChange={(e) => setSubscriptionCode(e.target.value)}
                  placeholder="مثال: ABC-123-XYZ"
                />
                <ShieldCheck size={20} className="input-icon" />
              </div>

              {error && (
                <motion.div
                  initial={{ opacity: 0, x: -10 }}
                  animate={{ opacity: 1, x: 0 }}
                  className="error-msg"
                >
                  <AlertCircle size={16} />
                  <span>{error}</span>
                </motion.div>
              )}

              <button
                className={`submit-btn ${loading ? 'is-loading' : ''}`}
                onClick={handleSubmit}
                disabled={loading}
              >
                {loading ? <Loader2 className="spinner" /> : "تفعيل الآن"}
              </button>
            </div>
          ) : (
            <motion.div
              className="success-body"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
            >
              <div className="success-lottie">
                <div className="check-mark">L</div> {/* يمكن استبدالها بـ SVG check */}
              </div>
              <h3>تم التفعيل بنجاح!</h3>
              <p>مبروك! تم فتح المحتوى، يمكنك البدء الآن</p>
              <button className="done-btn" onClick={onClose}>بدء المشاهدة</button>
            </motion.div>
          )}
        </motion.div>
      </AnimatePresence>
    </div>
  );
};

export default SubscriptionModal;